import { useStaticQuery, graphql } from "gatsby"

export const useServiceAreasQuery = () => {
  const { wpPage } = useStaticQuery(
    graphql`
      query ServiceAreasQuery {
        wpPage(title: { eq: "Home" }) {
          serviceAreas {
            serviceAreasMapUrlDesktop {
              localFile {
                childImageSharp {
                  gatsbyImageData
                }
              }
            }
            serviceAreasMapUrlMobile {
              localFile {
                childImageSharp {
                  gatsbyImageData
                }
              }
            }
            serviceAreasHeading
            serviceAreasAreas {
              serviceAreasLabel
              serviceAreasLocations
            }
            locationIcon {
              localFile {
                childSvg {
                  content {
                    data
                  }
                }
              }
            }
          }
        }
      }
    `
  )
  return wpPage.serviceAreas
}
